export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Llámanos si tienes preguntas; las llamadas siempre se tratan de forma confidencial',
        subtitleInfo1: 'Hemos elaborado también una lista de ',
        faq: 'Preguntas frecuentes',
        subtitleInfo2: ', en la que encontrarás respuesta a la mayoría de las dudas sobre el ',
        subtitleInfo3: ' sistema de denuncia de irregularidades.',
    }
};
